import styled from 'styled-components'

import { MobileInput as _MobileInput, Col as _Col } from '../styles'

export const MobileInput = styled(_MobileInput)`
    position: absolute;
`

export const SameAsParentLabel = styled.label`
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    margin: 0.2rem 0;
    color: var(--oh-grey);
    font-family: Avenir;
    position: absolute;
    bottom: ${({ hasError }) => `${hasError ? '-20' : '-10'}px`};

    @media (max-width: 700px) {
        font-size: 0.8rem;
    }
`

export const SameAsParentCheckbox = styled.input``

export const SameAsParentSpan = styled.span``

export const Col = styled(_Col)`
    height: 80px;
    position: relative;
`

export const MobileInputWrapper = styled.div`
    width: 100%;
    position: relative;
    height: 100%;
`

export const Tooltip = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 5px;

    position: absolute;
    width: 103px;
    height: 20px;

    background: #333333;
    border-radius: 5px;

    color: white;
    font-size: 10px;
    right: 0;
    top: -10px;
    cursor: default;
    ${props =>
        props.visible
            ? `visibility: visible; opacity: 1;`
            : `visibility: hidden; opacity: 0;`};

    transition: opacity 1s;

    /* bottom arrow */
    ::after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 77%;
        margin-bottom: -9.5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent transparent #333333;
        transform: rotate(90deg);
    }
`

export const InfoWrapper = styled.div`
    :hover {
        ${Tooltip} {
            visibility: visible;
            opacity: 1;
        }
    }
`

export const InfoIcon = styled.div`
    background: #f3c520;

    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bolder;

    position: absolute;
    top: 25px;
    right: 10px;
    cursor: pointer;

    ::after {
        content: 'i';
    }
`
